import React from "react";
import { createPortal } from "react-dom";

export default function PortalDropdown({ children, style, className }) {
  if (typeof document === "undefined") return null;
  return createPortal(
    <div style={style} className={className}>
      {children}
    </div>,
    document.body
  );
}
